import React from "react"
import * as PropTypes from "prop-types";
import styled from "styled-components"
import DesktopHeader from "./desktop-header";
import MobileHeader from "./mobile-header";

const Container = styled.header`
  z-index: 2;
  width: 100%;
  position: relative;
  
  ::after {
    content: '';
    box-shadow: 0 4px 8px rgba(31, 41, 46, 0.16), 0 16px 16px rgba(31, 41, 46, 0.08);
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    pointer-events: none;
  }
  
  @media (max-width: ${props => props.theme.mobileWidth}) {
    position: fixed;
    top: 0;
    left: 0;
  }
`;

const Desktop = styled(DesktopHeader)`
  @media (max-width: ${props => props.theme.mobileWidth}) {
    display: none;
  }
`;

const Mobile = styled(MobileHeader)`
  @media (min-width: ${props => props.theme.mobileWidth}) {
    display: none;
  }
`;

const Header = ({ className, page }) => (
  <Container className={className}>
    <Desktop page={page}/>
    <Mobile page={page}/>
  </Container>
);

Header.propTypes = {
  page: PropTypes.string.isRequired
};

export default Header
